var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHandlike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 74,
    viewBox: "0 0 73 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6667 70.3334H10.6667C8.89856 70.3334 7.20286 69.631 5.95262 68.3807C4.70238 67.1305 4 65.4348 4 63.6667V40.3334C4 38.5652 4.70238 36.8696 5.95262 35.6193C7.20286 34.3691 8.89856 33.6667 10.6667 33.6667H20.6667M44 27V13.6667C44 11.0145 42.9464 8.47098 41.0711 6.59562C39.1957 4.72026 36.6522 3.66669 34 3.66669L20.6667 33.6667V70.3334H58.2667C59.8744 70.3515 61.4346 69.788 62.6597 68.7467C63.8848 67.7054 64.6923 66.2564 64.9333 64.6667L69.5333 34.6667C69.6784 33.7112 69.6139 32.7356 69.3445 31.8075C69.075 30.8794 68.607 30.021 67.9729 29.2917C67.3387 28.5625 66.5536 27.9798 65.6719 27.5841C64.7902 27.1884 63.833 26.9891 62.8667 27H44Z",
    stroke: "white",
    strokeWidth: 6.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandlike);
export default __webpack_public_path__ + "static/media/hand like.165ef870d13fcd25ec99fcb619f6dda4.svg";
export { ForwardRef as ReactComponent };